import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

export const ReportsModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8, 10, 37, 0.1),
    0 0.9375rem 1.40625rem rgba(8, 10, 37, 0.1),
    0 0.25rem 0.53125rem rgba(8, 10, 37, 0.15),
    0 0.125rem 0.1875rem rgba(8, 10, 37, 0.1);
  width: 450px;
  max-height: 80vh;
  overflow-y: auto;

  .range_picker {
    width: 100%;
  }

  .range_picker .ant-picker {
    width: 100%;
  }

  .ant-radio-wrapper {
    margin-bottom: 3px;
    color: #101010;
    margin-right: 0;
  }

  .action_button {
    background-color: ${COLORS.transparentDark};
    margin: 10px 0 0 0;
    padding: 10px 30px;
    border-radius: 3px;
    font-size: 13px;
    color: #444;
    text-decoration: none;
    transition: background-color 200ms ease-in-out;

    :disabled {
      color: rgba(0, 0, 0, 0.25);
      background-color: #f5f5f5;
      cursor: not-allowed;
      opacity: 1;

      :hover {
        color: rgba(0, 0, 0, 0.25);
        background-color: #f5f5f5;
      }
    }
  }

  .action_button_download {
    padding-bottom: 5px;
    margin-top: 3px;
    background-color: ${COLORS.transparentDark};
    border-radius: 3px;
    font-size: 13px;
    color: #444;
    border: none;
    transition: background-color 200ms ease-in-out;

    :hover {
      background-color: ${({ theme }) => theme.hoveredDiv};
      color: ${COLORS.primary};
    }
  }
`;

export const Div = styled.div`
  padding: 24px 24px 70px;

  .card_header .card_value_label {
    width: 100%;

    .main_card_text {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-height: 1rem;
    }
  }

  .action_button {
    margin-left: 24px;
    padding: 10px 30px;
    border-radius: 3px;
    font-size: 13px;
    text-decoration: none;
    transition: background-color 200ms ease-in-out;
    height: 40px;
    white-space: nowrap;
  }

  .colored_connector_icons {
    width: 20px;
    margin: 0 25px 0 0;
  }

  .thunder_icon {
    width: 20px;
    margin-right: 5px;
  }

  .chager_plug_icon {
    width: 20px;
    margin-right: 5px;
  }

  .connector_header_item_clicked .connector_dropdown {
    opacity: 1;
    pointer-events: all;
  }

  .current_value {
    margin-right: 6px;
  }

  .card_in_list.gabrr_expanded {
    height: 500px;
  }
`;

export const InputReportWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  margin-bottom: 0;
`;

export const FormInputWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const InputDocument = styled.input.attrs(() => ({
  type: 'text',
  maxLength: 18, // suficiente pra CNPJ formatado
}))`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 13px;

  &:focus {
    outline: none;
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);
  }
`;

export const InputCostKwh = styled.input.attrs(() => ({
  type: 'number',
  maxLength: 8,
}))`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 13px;

  &:focus {
    outline: none;
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);
  }
`;

export const InputIncomeKwh = styled.input.attrs(() => ({
  type: 'number',
  maxLength: 8,
}))`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 13px;

  &:focus {
    outline: none;
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);
  }
`;

export const FormLabel = styled.label`
  font-size: 12px;
  font-weight: 400;
  color: #101010;
  margin: 0;
`;

export const ReportModalTitle = styled.h2`
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const ReportModalDivider = styled.div`
  width: calc(100% + 48px);
  height: 1px;
  background-color: #e8e8e8;
  margin: 0 -24px 20px -24px;
`;

export const ReportModalDividerNormal = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e8e8e8;
  margin-bottom: 20px;
`;

export const ReportModalDividerSmall = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e8e8e8;
  margin-top: -15px;
  margin-bottom: 20px;
`;

export const ReportModalContent = styled.div`
  width: 100%;
`;

export const ReportModalSection = styled.div`
  margin-bottom: 20px;
  width: 100%;

  &:last-of-type {
    margin-bottom: 24px;
  }
`;

export const ReportModalSectionTitle = styled.label`
  display: block;
  font-size: 15px;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  line-height: 15px;
`;

export const ReportModalButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  width: 100%;
`;

export const SelectTenantWrapper = styled.div`
  position: absolute;
  z-index: 5;
  right: 220px;
  margin-top: 10px;
`;

export const Title = styled.h1`
  display: flex;
  margin: 0;
  font-size: 21px;
  font-weight: 600;
  font-family: 'Roboto';
  color: #000;
  align-items: center;

  @media (min-width: 1025px) {
    padding-left: 4px;
    margin-bottom: 8px;
  }

  @media (min-width: 1921px) {
    margin-bottom: 0;
  }

  .wrapper-icon {
    align-items: center;
    display: flex;
    margin-right: 16px;
  }
`;

export const Toolsbar = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  margin-top: 24px;
`;

export const Button = styled(ButtonAntD)`
  &.ant-btn-default {
    &:hover,
    &:active,
    &:focus {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};

    &:hover {
      background-color: ${({ theme }) => theme.primary};
      border-color: ${({ theme }) => theme.hoveredDiv};
    }
  }
`;

export const SwitchWrapper = styled.div`
  .ant-switch-checked {
    background-color: ${({ theme }) => theme.primary};
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 35px;
  line-height: 1;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.7;
    color: #000;
    transform: scale(1.1);
  }
`;
